const bootstrap = require('bootstrap');
const calculation_markup = require('./../views/calculator/calculation_markup.html');
const print_markup = require('./../views/calculator/print_markup.html');
const axios = require('axios');

export class CalculatorClass {
    MINIMUM_NUMBER_OF_BOOK_COPIES = 17;
    CIRCULATION_MIN = 1;
    CIRCULATION_MAX = 1000;

    _calculation_markup = calculation_markup;
    _print_markup = print_markup;

    constructor(type, orderId = null, callback = null) {
        this.type = type;
        this._orderId = orderId;
        this.callback = callback;
        this.cdekWidgetLoaded = false;
        this.promise = null;

        if (this.type === 'print') {
            this.bootstrapCdekModal = new bootstrap.Modal(document.getElementById('editus-modal-for-cdek-widget'));
        }
        let container = document.querySelector('.editus-calculator');

        if (container) {
            switch (this.type) {
                case 'print':
                    container.innerHTML = this.print_markup;
                    break;
                case 'calculation':
                    container.innerHTML = this.calculation_markup;
                    break;
                default:
                    throw new Error("Указан неверный тип калькулятора!");
            }
            this.overlay = document.getElementById('editus-calculator-overlay');
            this.calculateForm = document.getElementById('calculate-form');
            this.calculateForm.action = `/ajax/print/${orderId}/save-book-options`;
            this.coverType = document.querySelector('[name=cover_type]');
            this.colorBlock = document.querySelector('[name=is_colored]');
            this.deliveryServiceWrapper = document.querySelector(".delivery-service-wrapper");
            this.deliveryType = document.querySelector("[name='delivery_type']");
            this.deliveryPriceInput = document.querySelector("[name='delivery_price']");
            this.deliveryTypeRadios = document.querySelector("[name='delivery_type_radio']");
            this.pageCount = document.querySelector("[name=page_count]");
            this.binding = document.querySelector("[name=binding_id]");
            this.circulation = document.querySelector("[name=circulation]");
            this.hasISBN = document.querySelector("[name=has_isbn]");
            this.submitBtn = document.getElementById('calculate-form-submit-btn');
            this._init();
        } else {
            throw new Error("Отсутствует контейнер для калькулятора");
        }
    }

    get calculation_markup() {
        return this._calculation_markup;
    }

    get print_markup() {
        return this._print_markup;
    }

    _init() {
        this.calculateForm.onchange = () => {
            this.circulation.max = 1000;

            if (this.circulation.value > this.CIRCULATION_MAX) {
                this.circulation.value = this.CIRCULATION_MAX;
            }
            if (this.type === "print" && this.deliveryTypeRadios.value === "none") {
                this.submitBtn.setAttribute('disabled', '');
                document.getElementById('delivery-cost').innerText = 0 + " руб.";
                this.deliveryPriceInput.value = 0;
            }

            this.calculate().then(() => {
                if (this.type === "print"
                    && this.deliveryTypeRadios.value === "courier"
                    && this.deliveryPriceInput.value == 0) {
                    this.submitBtn.classList.add('d-none');
                }
            });
        };
        this.calculateForm.onsubmit = (evt) => {
            if (this.type === "calculation") {
                evt.preventDefault();
            }
            if (this.type === "print") {
                evt.preventDefault();

                if (this.deliveryTypeRadios.value === "none") {
                    this.submitBtn.setAttribute('disabled', '');
                    alert('Выберите доставку.');
                    return;
                }
                let csrfInput = document.createElement("input");
                let orderIdInput = document.createElement("input");

                csrfInput.value = document.querySelector("[name='csrf-token']").getAttribute('content');
                csrfInput.name = "_token";
                csrfInput.type = "hidden";

                orderIdInput.value = this._orderId;
                orderIdInput.name = "order_id";
                orderIdInput.type = "hidden";

                this.calculateForm.appendChild(csrfInput);
                this.calculateForm.appendChild(orderIdInput);
                this.calculateForm.submit();
            }

        };
        this.coverType.onchange = () => {
            this.promise = this.getBindings(this.coverType.value).then(() => {
                if (this.type === "calculation") {
                    this.checkPageCount();
                }
            });
        };
        this.colorBlock.onchange = () => {
            this.promise = this.getPaperTypes(this.colorBlock.value);
        };

        if (this.type === "print") {
            this.deliveryTypeRadios.onchange = () => {
                if (this.deliveryTypeRadios.value !== "none") {
                    this.submitBtn.removeAttribute('disabled');
                }

                if (this.deliveryTypeRadios.value === "courier") {
                    this.submitBtn.classList.add('d-none');
                    this.deliveryServiceWrapper.classList.remove("d-none");
                    this.bootstrapCdekModal.show();
                } else if (this.deliveryTypeRadios.value === "pickup") {
                    this.deliveryType.value = 'pickup';
                    this.deliveryPriceInput.value = 0;
                    document.getElementById('delivery-cost').innerText = this.deliveryPriceInput.value + " руб."
                    document.querySelector("[name='receiver_city_id']").value = null;
                    document.querySelector("[name='tariff_id']").value = null;
                    document.querySelector("[name='delivery_address']").value = null;
                    document.querySelector("[name='delivery_cdek_pvz_code']").value = null;
                    this.bootstrapCdekModal.hide();
                    this.deliveryServiceWrapper.classList.add("d-none");
                    this.submitBtn.classList.remove('d-none');
                }

                if (!this.cdekWidgetLoaded) {
                    this.loadCDEKWidget()
                }
            };
        }

        this.binding.onchange = () => {
            if (this.type === "calculation") {
                this.checkPageCount();
            }
        };

        if (this.type === "calculation") {
            this.pageCount.onchange = () => {
                this.checkPageCount()
            };
        }

        this.circulation.onchange = async () => {
            if (this.hasISBN.checked && this.circulation.value < this.MINIMUM_NUMBER_OF_BOOK_COPIES) {
                this.circulation.value = +this.circulation.value + (this.MINIMUM_NUMBER_OF_BOOK_COPIES - this.circulation.value);
            }
            if (this.circulation.value < this.CIRCULATION_MIN) {
                this.circulation.value = this.CIRCULATION_MIN;
            }
            if (this.circulation.value > this.CIRCULATION_MAX) {
                this.circulation.value = this.CIRCULATION_MAX;
            }

            if (this.type === "print" && this.deliveryType.value !== "pickup" && this.receiverCityId) {
                this.getDeliveryPrice(this.receiverCityId, this.deliveryType.value).then((value) => {
                    this.deliveryPriceInput.value = value.price + 35; // 35 Допупаковка
                    this.calculate();
                }, (reason) => {
                    console.log(reason); // Ошибка!
                });
            } else {
                this.calculate();
            }
        };

        this.hasISBN.onchange = () => {
            if (this.hasISBN.checked) {
                if (this.circulation.value < this.MINIMUM_NUMBER_OF_BOOK_COPIES) {
                    this.circulation.value = +this.MINIMUM_NUMBER_OF_BOOK_COPIES;
                }
                document.getElementById('isbn-text').classList.remove('d-none');
            } else {
                document.getElementById('isbn-text').classList.add('d-none');
            }
            this.calculate();
        };


        this.getPaperTypes(false).then(() => {
            if (this.type === "calculation") {
                this.getPaperFormats().then(() => {
                    this.getBindings("soft").then(() => {
                        this.calculate();
                    });
                });
            } else {
                this.getBindings("soft").then((result) => {
                    if (result.length === 0) {
                        this.coverType.remove(this.coverType.selectedIndex);
                        this.coverType.value = "hard";
                        this.coverType.dispatchEvent(new Event('change'));
                    }

                    this.calculate();
                });
            }
        });
    }

    showOverlay() {
        this.overlay.classList.remove('d-none');
    }

    hideOverlay() {
        this.overlay.classList.add('d-none');
    }

    checkPageCount() {
        const minPagesCount = this.binding.options[this.binding.selectedIndex].dataset.min;
        const maxPagesCount = this.binding.options[this.binding.selectedIndex].dataset.max;
        const multiplicity = this.binding.options[this.binding.selectedIndex].dataset.multiplicity;

        if (+this.pageCount.value < +minPagesCount) {
            this.pageCount.value = minPagesCount;
        } else if (+this.pageCount.value > +maxPagesCount) {
            this.pageCount.value = maxPagesCount;
        } else if (this.pageCount.value % (+multiplicity) !== 0) {
            let pageCountDiff = +(-this.pageCount.value % (+multiplicity)) + (+multiplicity);
            this.pageCount.value = +this.pageCount.value + pageCountDiff;
        }
        this.calculate();
    }

    async getPaperFormats() {
        try {
            const response = await fetch('/ajax/get-paper-formats', {
                method: 'GET',
            });
            const result = await response.json();

            let innerHtml = '';
            result.forEach(paper => {
                innerHtml += `<option value="${paper.id}" ${paper.id === 3 ? 'selected' : ''}>${paper.name} (${paper.width + 'x' + paper.height})</option>`;
            });
            document.querySelector('[name=paper_format_id]').innerHTML = innerHtml;
        } catch (error) {
            console.error('Ошибка:', error);
        }
    }

    async getPaperTypes(is_colored) {
        try {
            const response = await fetch('/ajax/getpaperblock?is_colored=' + (+is_colored), {
                method: 'GET',
            });
            const result = await response.json();

            let innerHtml = '';
            result.forEach(paper => {
                innerHtml += `<option value="${paper.id}">${paper.name + ' ' + paper.density}</option>`;
            });
            document.querySelector('[name=paper_type_id]').innerHTML = innerHtml;
        } catch (error) {
            console.error('Ошибка:', error);
        }
    }

    async getBindings(coverType) {
        let url = '/ajax/getbindingtypes?covertype=' + coverType;

        switch (this.type) {
            case "print":
                url += '&order_id=' + this._orderId;
                break;
        }
        try {
            const response = await fetch(url, {
                method: 'GET',
            });
            const result = await response.json();

            let innerHtml = '';
            let selected = '';

            result.forEach(binding => {
                if (binding.id === 3) {
                    selected = 'selected';
                }
                innerHtml += `<option value="${binding.id}" data-multiplicity="${binding.multiplicity}" data-min="${binding.min}" data-max="${binding.max}" ${selected}>${binding.name}</option>`;
                selected = '';
            });
            this.binding.innerHTML = innerHtml;
            return result;
        } catch (error) {
            console.error('Ошибка:', error);
        }
    }

    async calculate() {
        if (this.promise) {
            this.promise.then(() => {
                this.promise = null;

                return this.realCalculate();
            })
        } else {
            return this.realCalculate();
        }
    }

    async realCalculate() {
        this.submitBtn.classList.add('d-none');
        const formData = new FormData(this.calculateForm);
        let url = '/ajax/calculate';

        if (!formData.get('binding_id')) {
            return;
        }

        switch (this.type) {
            case "print":
                url += '?order_id=' + this._orderId;
                break;
        }

        try {
            this.showOverlay();

            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector("[name='csrf-token']").getAttribute('content')
                }
            };

            axios.post(url, formData, config)
                .then((response) => {
                    const result = response.data;

                    switch (this.type) {
                        case "print":
                            document.getElementById('delivery-cost').innerText = this.deliveryPriceInput.value + " руб.";
                            document.getElementById("copy-cost").innerText = Math.round((result.total / formData.get("circulation"))) + " руб.";
                            break;
                        case "calculation":
                            document.getElementById("copy-cost").innerText = Math.round((result.total / formData.get("circulation"))) + " руб.";
                            break;
                    }
                    document.getElementById("circulation-cost-with-discount").innerText = result.total_with_discount + " руб.";
                    document.getElementById("circulation-cost").innerText = result.total + " руб.";
                    document.getElementById('date').innerText = result.date;

                    if (this.callback) {
                        this.callback(result.total, formData.get("circulation"));
                    }
                })
                .catch(function (error) {
                    console.log(error);
                })
                .finally(() => {
                    this.hideOverlay();
                });
        } catch (error) {
            console.error('Ошибка:', error);
        }
        this.submitBtn.classList.remove('d-none');
    }

    loadCDEKWidget() {
        const loadScriptPromise = new Promise((resolve, reject) => {
            let script = document.createElement('script');
            script.type = "text/javascript";
            script.src = "https://cdn.jsdelivr.net/npm/@cdek-it/widget@3";
            script.charset = "utf-8";
            document.body.append(script);

            script.onload = resolve;
            script.onerror = reject;
        });
        return Promise.all([loadScriptPromise, this.getCDEKCargoWeight()])
            .then((values) => {
                let data = values[1];
                let weight = data.weight;

                const tariffMap = {
                    office: {
                        30: 136,
                        50: 234,
                        500: 291,
                    },
                    door: {
                        30: 137,
                        50: 233,
                        500: 294,
                    }
                };

                function getTariff(weightInKg, type) {
                    for (const [maxWeight, tariff] of Object.entries(tariffMap[type])) {
                        if (weightInKg <= maxWeight) {
                            return tariff;
                        }
                    }

                    return null;
                }
                const office = getTariff(weight / 1000, 'office');
                const door = getTariff(weight / 1000, 'door');

                window.cartWidjet = new window.CDEKWidget({
                    from: 'Москва',
                    root: 'cdek-widget',
                    apiKey: 'f42ba38d-0102-4595-8e20-663fcf64af3d',
                    servicePath: route('cdek.widget.info'),
                    defaultLocation: 'Москва',
                    popup: false,
                    goods: [{
                        length: 25,
                        width: 17,
                        height: 7,
                        weight: weight,
                    }],
                    tariffs: {
                        office: [office],
                        door: [door],
                    },

                    onReady: () => {
                        this.cdekWidgetLoaded = true;
                    },
                    /**
                     * @param deliveryMode (door | office)
                     * @param tariff
                     * @param address
                     */
                    onChoose: (deliveryMode, tariff, address) => {
                        this.onChooseCDEK(deliveryMode, tariff, address);
                    },
                });
            });
    }

    onChooseCDEK(deliveryMode, tariff, address) {
        console.log(deliveryMode, tariff, address);

        this.deliveryType.value = deliveryMode === "door" ? "сourier_cdek" : "pvz";
        this.receiverCityId = address.city_code ?? null;

        document.querySelector("[name='receiver_city_id']").value = address.city_code ?? null;
        document.querySelector("[name='tariff_id']").value = tariff.tariff_code;
        document.querySelector("[name='delivery_address']").value = address.formatted ?? address.name ?? null;
        document.querySelector("[name='delivery_cdek_pvz_code']").value = address.code ?? null;

        document.getElementById('editus-modal-overlay').classList.remove('d-none');

        if (this.receiverCityId) {
            this.applyCdekDeliveryPrice(this.receiverCityId, address.postal_code);
        } else {
            this.getCityByPostalCode(address.postal_code).then((value) => {
                this.receiverCityId = value.city_code ?? null;

                this.applyCdekDeliveryPrice(value.city_code ?? null, address.postal_code);
            }, (reason) => {
                // Ошибка!
                alert(reason);
                console.log(reason);
                document.getElementById('editus-modal-overlay').classList.add('d-none');
                this.bootstrapCdekModal.hide();
            });
        }
    }

    applyCdekDeliveryPrice(city_code, postal_code) {
        document.querySelector("[name='receiver_city_id']").value = city_code ?? null;

        this.getDeliveryPrice(this.receiverCityId, this.deliveryType.value, postal_code).then((value) => {
            this.submitBtn.classList.remove('d-none');
            this.deliveryPriceInput.value = value.price;
            this.calculate();

            document.getElementById('editus-modal-overlay').classList.add('d-none');
            this.bootstrapCdekModal.hide();
        }, (reason) => {
            // Ошибка!
            alert(reason);
            console.log(reason);
            document.getElementById('editus-modal-overlay').classList.add('d-none');
            this.bootstrapCdekModal.hide();
        });
    }

    async getCityByPostalCode(postalCode) {
        let formData = new FormData();

        formData.append('_token', document.querySelector("[name='csrf-token']").getAttribute('content'));
        formData.append('postal_code', postalCode);

        let response = await fetch(route('book.options.get.city'), {
            method: 'POST',
            body: formData,
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            },
        });
        return await response.json();
    }

    async getDeliveryPrice(receiverCityId, deliveryTypeValue, postalCode) {
        let formData = new FormData();

        formData.append('_token', document.querySelector("[name='csrf-token']").getAttribute('content'));
        formData.append('circulation', this.circulation.value);
        formData.append('cover_type', this.coverType.value);
        formData.append('has_isbn', this.hasISBN.checked ? 1 : 0);

        if (receiverCityId) {
            formData.append('receiver_city_id', receiverCityId);
        }
        formData.append('postal_code', postalCode);
        formData.append('delivery_type', deliveryTypeValue);

        let response = await fetch(route('book.options.get.delivery.price', [this._orderId]), {
            method: 'POST',
            body: formData,
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            },
        });
        return await response.json();
    }

    /**
     *
     * @returns {Promise<any>}
     */
    async getCDEKCargoWeight() {
        let formData = new FormData();

        let hasISBN = document.querySelector("[name='has_isbn']:checked");

        formData.append('_token', document.querySelector("[name='csrf-token']").getAttribute('content'));
        formData.append('circulation', this.circulation.value);
        formData.append('cover_type', this.coverType.value);
        formData.append('has_isbn', hasISBN ? hasISBN.value : '0');

        let response = await fetch(route('book.options.get.cargo.weight', [this._orderId]), {
            method: 'POST',
            body: formData,
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            },
        });
        return await response.json();
    }
}


